import { useCallback, useState } from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';

import { getStartMessageGPT } from '../../../crud/chat.crud';
import type { TMessageGPT } from './useGetMessagesGPT';
import { useFormatMessage } from '../../../hooks';
import { getResponseMessage } from '../../../utils/utils';

export const useGetStartMessage = () => {
  const intl = useIntl();
  const fm = useFormatMessage();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingGPT, setLoading] = useState(false);
  const [startMessage, setMessages] = useState<TMessageGPT[] | null>(null);

  const fetchStartMessage = useCallback(async () => {
    setLoading(true);
    getStartMessageGPT(intl.locale)
      .then((res: any) => {
        if (res.data.data.value) {
          setMessages([
            {
              content: res.data.data.value,
              role: 'assistant',
              id: 'start_message',
              date: moment().format('DD.MM.YYYY HH:mm:ss'),
            },
          ]);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [intl.locale, moment]);

  return { fetchStartMessage, loadingGPT, startMessage };
};
